import { registerModal } from 'features/Modal/ModalRegistry'
import BillingAddCreditCardFormModal from './BillingAddCreditCardFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'BILLING_ADD_CREDIT_CARD'
registerModal(modalType, BillingAddCreditCardFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddCreditCardFormModal/BillingAddCreditCardFormModal.action.js